<template>
    <div v-if="modelValue" class="ds-confirm-overlay" @click.self="handleCancel">
        <div class="ds-confirm-dialog">
            <div class="ds-confirm-title">{{ title }}</div>
            <div v-if="text" class="ds-confirm-text">{{ text }}</div>
            <div class="ds-confirm-actions">
                <button class="ds-button-compact ds-button-compact-secondary" type="button" @click="handleCancel">
                    {{ cancelText }}
                </button>
                <button class="ds-button-compact ds-button-compact-primary" type="button" @click="handleConfirm">
                    {{ confirmText }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
interface Props {
    title: string
    text?: string
    confirmText?: string
    cancelText?: string
}

withDefaults(defineProps<Props>(), {
    confirmText: 'Подтвердить',
    cancelText: 'Отмена',
})

const modelValue = defineModel<boolean>({ required: true })

const emit = defineEmits<{
    confirm: []
    cancel: []
}>()

const handleConfirm = () => {
    modelValue.value = false
    emit('confirm')
}

const handleCancel = () => {
    modelValue.value = false
    emit('cancel')
}
</script>
